import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const RedoIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Redo",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M2.06 20.27c1.75-5.58 5.96-9.44 11.08-10.08s10.26 2 13.35 6.5v-5.43c0-.97.78-1.75 1.75-1.75s1.75.78 1.75 1.75v9.39c0 .49-.21.93-.53 1.25s-.75.51-1.23.52l-9.43-.02c-.97 0-1.75-.78-1.75-1.75s.78-1.75 1.75-1.75h4.93c-2.31-3.59-6.32-5.72-10.17-5.25s-6.84 3.41-8.15 7.66c-.24.69-.89 1.18-1.66 1.18a1.746 1.746 0 0 1-1.68-2.23Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M23.86 26.57c-.63 0-1.14-.51-1.14-1.14v-8c0-5.67-4.62-10.29-10.29-10.29S2.14 11.76 2.14 17.43v6.86a1.14 1.14 0 1 1-2.28 0v-6.86c0-6.93 5.64-12.57 12.57-12.57S25 10.5 25 17.43v8c0 .63-.51 1.14-1.14 1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M23.86 26.57c-.3 0-.59-.12-.81-.33l-6.86-6.86a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l6.05 6.05 6.05-6.05a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62l-6.86 6.86c-.21.21-.51.33-.81.33"
      })]
    })
  }));
};
RedoIcon.displayName = 'RedoIcon';